module.exports = __webpack_public_path__ + "img/og_logo.34964c00.png";